// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"single-story-m__content-wrapper__5ozsd","content":"single-story-m__content__36Npw","description":"single-story-m__description__3OwFa"};